import React, { useEffect, useState } from 'react';
import { PromotionData } from './FulfillmentOptions/types';

type PromoMessageProps = {
  promotionData: Array<PromotionData>;
  catentryId: string;
};

function ProductPromotion(props: Readonly<PromoMessageProps>) {
  const { promotionData, catentryId } = props;

  const [showPromoMessage, setShowPromoMessage] = useState(false);

  useEffect(() => {
    if (promotionData && catentryId && promotionData[catentryId]) {
      setShowPromoMessage(true);
    } else {
      setShowPromoMessage(false);
    }
  }, [promotionData]);

  if (showPromoMessage) {
    return (
      <div
        className="hmf-mb-xs hmf-text-align-left"
        key={`promotion_${catentryId}`}
        id={`promotion_${catentryId}`}
        style={{ display: 'block' }}
        data-testid={`quickViewModalpromotion${catentryId}`}>
        <span className="rs-fplp-promo hmf-body-m label-base" id={`promo_${catentryId}`}>
          {promotionData[catentryId].promoDesc}
        </span>
      </div>
    );
  }
  return null;
}

export default ProductPromotion;
